"use strict";

// angular.module('app').factory('ConfirmModelService', function($uibModal) {
module.exports = /*@ngInject*/function ($uibModal) {
  var service = {
    isOpen: false,
    ConfirmType: {
      DELETE: 'DELETE',
      SUCCESS: 'SUCCESS',
      INFO: 'INFO',
      CONFIRM: 'CONFIRM'
    },
    ConfirmMessages: {
      DELETE: 'Delete Confirmation',
      SUCCESS: 'Success',
      INFO: 'Message',
      CONFIRM: 'Confirmation'
    },
    /*
     Options
     - type: ConfirmType
     - model: {
            header: "String - header of the model - optional",
            message: "String - message to be displayed",
            buttons: {
                cancel: {
                    label: "Cancel"
                },
                ok: {
                    label: "OK"
                }
            },
            autoClose: "Boolean - true for auto close, default auto close for ConfirmType.SUCCESS & ConfirmType.INFO",
            autoCloseTimeout: "Number - in mile seconds, default 3000"
        }
     - callback: success callback
     */
    confirm: function confirm(type, model, callback) {
      if (service.isOpen) return true;
      var defaultOptions = {
        buttons: {
          cancel: {
            label: 'Cancel'
          },
          ok: {
            label: 'OK'
          }
        }
      };
      // eslint-disable-next-line no-param-reassign, prefer-object-spread
      model = Object.assign({}, defaultOptions, model || {});
      $uibModal.open({
        templateUrl: 'shared/components/confirm-model/_confirm-model.html',
        controllerAs: '$ctrl',
        windowTopClass: 'confirm-model',
        backdrop: 'static',
        // eslint-disable-next-line object-shorthand
        controller: function controller($uibModalInstance, $filter, $timeout) {
          var $ctrl = this;
          service.isOpen = true;
          $ctrl.confirmType = type;
          $ctrl.confirmHeader = model.header || service.ConfirmMessages[type] || 'Message';
          $ctrl.message = model.message;
          $ctrl.autoClose = type === service.ConfirmType.SUCCESS || type === service.ConfirmType.INFO || !!model.autoClose;
          $ctrl.autoCloseTimeout = model.autoCloseTimeout || 3000;
          $ctrl.buttons = model.buttons;
          $ctrl.headerClassMap = {
            DELETE: 'header-danger',
            SUCCESS: 'header-success',
            INFO: 'header-info',
            CONFIRM: 'header-info'
          };
          $ctrl.ok = function () {
            // eslint-disable-next-line no-undef
            (callback || angular.noop)();
            $ctrl.cancel();
          };
          $ctrl.cancel = function () {
            service.isOpen = false;
            $uibModalInstance.dismiss('cancel');
          };
          if ($ctrl.autoClose) {
            $timeout(function () {
              $ctrl.cancel();
            }, $ctrl.autoCloseTimeout);
          }
        }
      });
    }
  };
  return service;
};